(function () {
  // The block can re-render (product-rerender), so only ever initialise once
  if (window.__mhUpsellInit) return;
  window.__mhUpsellInit = true;

  const selected = new Set();   // selected upsell product ids
  const chosen = new Map();     // product id -> { variantId, color, img }
  let busy = false;
  let bypass = false;
  let modal = null;
  let activeCard = null;

  /* ---------- card state ---------- */
  function applyState() {
    document.querySelectorAll('.upsell-card').forEach(function (card) {
      const pid = card.dataset.productId;
      const on = selected.has(pid);
      card.classList.toggle('is-selected', on);
      card.setAttribute('aria-pressed', on ? 'true' : 'false');

      const c = chosen.get(pid);
      if (c) {
        card.dataset.variantId = c.variantId;
        const label = card.querySelector('.upsell-card__color');
        if (label) label.textContent = c.color;
        const img = card.querySelector('.upsell-card__image img');
        if (img && c.img && img.getAttribute('src') !== c.img) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = c.img;
        }
      }
    });
  }

  function getColors(card) {
    const el = card.querySelector('.upsell-card__colors');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function hasColors(card) {
    return card.dataset.hasColors === 'true' && getColors(card);
  }

  function toggleCard(card) {
    const pid = card.dataset.productId;
    if (selected.has(pid)) {
      selected.delete(pid);
      applyState();
    } else if (hasColors(card)) {
      openModal(card);          // pick color first, then it gets ticked
    } else {
      selected.add(pid);
      applyState();
    }
  }

  /* ---------- popup ---------- */
  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'upsell-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Choose color');
    modal.innerHTML =
      '<div class="upsell-modal__overlay" data-close></div>' +
      '<div class="upsell-modal__panel">' +
        '<div class="upsell-modal__header">' +
          '<h3 class="upsell-modal__title">Choose color</h3>' +
          '<button type="button" class="upsell-modal__close" data-close aria-label="Close">' +
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="upsell-modal__list"></div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) return closeModal();
      const btn = e.target.closest('.upsell-modal__choose');
      if (btn && !btn.disabled) chooseColor(btn.dataset.index);
    });
  }

  function openModal(card) {
    const data = getColors(card);
    if (!data) return;
    if (!modal) buildModal();
    activeCard = card;

    const currentId = String((chosen.get(card.dataset.productId) || {}).variantId || card.dataset.variantId);
    const list = modal.querySelector('.upsell-modal__list');
    list.innerHTML = '';

    data.colors.forEach(function (c, i) {
      const row = document.createElement('div');
      row.className = 'upsell-modal__row' + (String(c.id) === currentId ? ' is-current' : '');

      const thumb = document.createElement('div');
      thumb.className = 'upsell-modal__thumb';
      if (c.img) {
        const img = document.createElement('img');
        img.src = c.img; img.alt = ''; img.loading = 'lazy';
        thumb.appendChild(img);
      }

      const name = document.createElement('div');
      name.className = 'upsell-modal__name';
      name.textContent = data.title;
      const sub = document.createElement('small');
      sub.textContent = c.value;
      name.appendChild(sub);

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'upsell-modal__choose';
      btn.dataset.index = i;
      btn.textContent = c.available ? 'Choose' : 'Sold out';
      btn.disabled = !c.available;

      row.append(thumb, name, btn);
      list.appendChild(row);
    });

    document.documentElement.classList.add('upsell-modal-lock');
    modal.classList.add('is-open');
    const first = modal.querySelector('.upsell-modal__choose:not(:disabled)');
    if (first) first.focus({ preventScroll: true });
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('upsell-modal-lock');
    if (activeCard) activeCard.focus({ preventScroll: true });
    activeCard = null;
  }

  function chooseColor(index) {
    if (!activeCard) return;
    const data = getColors(activeCard);
    const c = data && data.colors[parseInt(index, 10)];
    if (!c) return;

    const pid = activeCard.dataset.productId;
    chosen.set(pid, { variantId: String(c.id), color: c.value, img: c.img });
    selected.add(pid);          // choosing a color also selects the upsell
    applyState();
    closeModal();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal();
  });

  /* ---------- card interactions ---------- */
  document.addEventListener('click', function (e) {
    if (busy) return;

    // Clicking the underlined color text re-opens the popup
    const trigger = e.target.closest('[data-color-trigger]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      openModal(trigger.closest('.upsell-card'));
      return;
    }

    const card = e.target.closest('.upsell-card');
    if (card) toggleCard(card);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (busy) return;

    const trigger = e.target.closest('[data-color-trigger]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      openModal(trigger.closest('.upsell-card'));
      return;
    }

    const card = e.target.closest('.upsell-card');
    if (!card) return;
    e.preventDefault();
    toggleCard(card);
  });

  /* ---------- Add to cart interception ---------- */
  document.addEventListener('click', async function (e) {
    const atc = e.target.closest('.js-custom-atc');
    if (!atc) return;

    if (bypass) { bypass = false; return; }
    if (busy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    if (!selected.size) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    busy = true;
    atc.classList.add('is-loading');
    document.querySelectorAll('.upsell-products').forEach(function (el) { el.classList.add('is-busy'); });

    try {
      const items = [];
      selected.forEach(function (pid) {
        const c = chosen.get(pid);
        let variantId = c && c.variantId;
        if (!variantId) {
          const card = document.querySelector('.upsell-card[data-product-id="' + pid + '"]');
          variantId = card && card.dataset.variantId;
        }
        if (variantId) items.push({ id: parseInt(variantId, 10), quantity: 1 });
      });

      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });

      if (res.ok) {
        selected.clear();   // added, so don't add them again next time
        applyState();
      } else {
        console.error('Upsell add failed:', res.status, await res.text());
      }
    } catch (err) {
      console.error('Upsell add error:', err);
    }

    busy = false;
    atc.classList.remove('is-loading');
    document.querySelectorAll('.upsell-products').forEach(function (el) { el.classList.remove('is-busy'); });

    bypass = true;
    try { atc.click(); } finally { bypass = false; }
  }, true);

  /* ---------- Re-apply state after re-renders ---------- */
  let raf;
  new MutationObserver(function () {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(applyState);
  }).observe(document.body, { childList: true, subtree: true });
})();
